import React, { useEffect, useState } from 'react';
import '../styles/Dashboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faRocket, faComments, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import ChatbotManager from './ChatbotManager';

const Dashboard: React.FC = () => {
  const [userData, setUserData] = useState<any>(null);
  const [greeting, setGreeting] = useState('');
  
  useEffect(() => {
    // Get user data from local storage
    const storedUserData = localStorage.getItem('user_data');
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
    
    // Set appropriate greeting based on time of day
    const hour = new Date().getHours();
    if (hour < 12) {
      setGreeting('Good morning');
    } else if (hour < 18) {
      setGreeting('Good afternoon');
    } else {
      setGreeting('Good evening');
    }
  }, []);

  return (
    <div className="dashboard-container">
      {/* Stylized welcome header */}
      {userData && (
        <div className="welcome-header">
          <div className="welcome-content">
            <h1 className="welcome-title">
              {greeting}, {(
                userData.displayName
                  ? userData.displayName.split(' ')[0]
                  : userData.displayName || (userData.email ? userData.email.split('@')[0] : 'User')
              )}!
            </h1>
            <p className="welcome-subtitle">Welcome to your CLAI dashboard</p>
          </div>
          <div className="welcome-decoration"></div>
        </div>
      )}
      
      <div className="dashboard-content">
        <ChatbotManager />
        <div className="dashboard-stats">
          <div className="stat-card">
            <div className="stat-icon">
              <FontAwesomeIcon icon={faChartLine} />
            </div>
            <div className="stat-info">
              <h3>Bot Interactions</h3>
              <p className="stat-value">0</p>
              <p className="stat-description">Total conversations</p>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon">
              <FontAwesomeIcon icon={faRocket} />
            </div>
            <div className="stat-info">
              <h3>Deployments</h3>
              <p className="stat-value">0</p>
              <p className="stat-description">Active deployments</p>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon">
              <FontAwesomeIcon icon={faComments} />
            </div>
            <div className="stat-info">
              <h3>Messages</h3>
              <p className="stat-value">0</p>
              <p className="stat-description">Messages exchanged</p>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon">
              <FontAwesomeIcon icon={faCalendarAlt} />
            </div>
            <div className="stat-info">
              <h3>Account Age</h3>
              <p className="stat-value">New</p>
              <p className="stat-description">Account created recently</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;